export default __webpack_public_path__ + "static/media/saved.77ead215.png";